import { render, staticRenderFns } from "./ConfirmItemModal.vue?vue&type=template&id=28e98f0d"
import script from "./ConfirmItemModal.vue?vue&type=script&lang=js"
export * from "./ConfirmItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports